module.exports = __webpack_public_path__ + "img/eductorenviro_parked.9e0cd1f9.svg";